import { Injectable } from '@angular/core';
import { DataService } from 'projects/Autofacets-Core/src/app/services/data.service';
import { Urls } from 'projects/Autofacets-Core/src/app/utils/urls';

@Injectable({
  providedIn: 'root'
})
export class RomnasDataService {

  constructor(private dataProvider: DataService) { }

  async GetRomnasAutoLoginUrl(model:any):Promise<any>{
    return this.dataProvider.Post<any>(Urls.GetRomnasAutoLoginUrl,model).toPromise();
  }
  async ImportRomnasBasket(model:any):Promise<any>{
    return this.dataProvider.Post<any>(Urls.ImportRomnasBasket,model).toPromise();
  }
  async DeleteRomnas():Promise<any>{
    return this.dataProvider.Get<any>(Urls.DeleteRomnas).toPromise();
  }
}
